import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default {
    count: 0,
    show(options) {
        this.count++;
        NProgress.start()
        if (options && options.unclickable) document.body.classList.add('van-toast--unclickable')
    },
    close(options) {
        this.count--;
        if (this.count <= 0) {
            NProgress.done()
            document.body.classList.remove('van-toast--unclickable')
        }
    },
}
